export default __webpack_public_path__ + "static/media/mpv.9ab1a750.svg";